export default class Thumb {
  constructor () {
    this.Count = 0;
    // Sequence number of the element
    Object.defineProperty(this, 'number', { value: this.Count++ });

    // DB id
    this.id = null;
    this.name = '';

    // UI element id
    this.uuid = INKIVE.Math.generateUUID();

    // How many times this item used
    this.count = null;

    this.type = 'Thumb';
    this.width = 122.5;
    this.height = 76;

    this.tooltip = null;
    this.imageCheck = false;
    this.isDragable = true;
    this.visible = true;
  }

  setValues (values) {
    if (values === undefined) return;

    for (const key in values) {
      const newValue = values[key];

      if (newValue === undefined) {
        console.warn("INKIVE.Thumb: '" + key + "' parameter is undefined.");
        continue;
      }

      if (key in this) {
        this[key] = newValue;
      }
    }
  }

  getTooltipHtml () {
    return this.tooltip ? ' data-popover="tooltip" data-original-title="' + this.tooltip + '"' : '';
  }

  getA () {
    return '<a id="' + this.uuid + '" ' +
                'class="item" style="background-color: transparent !important;" ' +
                this.getTooltipHtml() +
                (this.id ? ' data-id="' + this.id + '"' : '') +
                '></a>';
  }

  getItemContainer () {
    const that = this;
    if (!this._container) {
      this._container = $.parseHTML('<div class="thumbnail">' + this.getA() + '</div>');

      if (this.width) {
        $(this._container).css('width', this.width);
      }

      if (this.height) {
        $(this._container).css('height', this.height);
      }

      if (this.isDragable) {
        $(this._container).initDragable({
          callback: {
            click: function (item, e) {
              if ($(e.target).closest('[data-type=delete]').length) {
                return;
              }
              that.onItemClick($(item).find('a').get(0), e);
            },
            mouseup: function (item, e) {
              if ($(e.target).closest('[data-type=delete]').length) {
                return;
              }
              that.onItemRelease($(item).find('a').get(0), e);
            },
            mousemove: function (item, e) {
              if ($(e.target).closest('[data-type=delete]').length) {
                return;
              }
              that.onItemMove($(item).find('a').get(0), e);
            }
          }
        });
      }
    }

    return $(this._container);
  }

  getItem () {
    const $container = this.getItemContainer();
    $container.find('a').attr('style', 'background:url(' + INKIVE.C.THUMB_NOCOVER + ') 50% 50%;background-size:100%;');

    return $container;
  }

  appendTo ($target) {
    $target = this.getTarget($target);

    const item = this.getItem();

    if (this.imageCheck) {
      $target.append(item).imagesLoaded(function (e) {
        $target.masonry();
        this.onItemLoad(item);
      });
    } else {
      $target.append(item);
      document.contains($target[0]) && $target.masonry('appended', item);
      this.onItemLoad(item);
    }

    this.postAppend();

    return this;
  }

  prependTo ($target) {
    $target = this.getTarget($target);
    const item = this.getItem();

    if (this.imageCheck) {
      $target.prepend(item).imagesLoaded(function (e) {
        $target.masonry();
        this.onItemLoad(item);
      });
    } else {
      $target.prepend(item).masonry('prepended', item);
      this.onItemLoad(item);
    }

    this.postAppend();

    return this;
  }

  postAppend () {
    const $container = this.getItemContainer();

    INKIVE.Helpers.initTooltips($container);
    INKIVE.Helpers.initPopover($container, { html: false });
  }

  onItemLoad (item) { }
  onItemClick (item, e) { }
  onItemRelease (item, e) { }
  onItemMove (item, e) { }

  getTarget ($target) {
    $target = $target.hasClass('thumbnail-wrapper')
      ? $target
      : $target.find('.thumbnail-wrapper');

    if (!$target.hasClass('thumbmenu')) {
      $target.addClass('thumbmenu');
    }

    return $target;
  }
}
